import { render, staticRenderFns } from "./tips2.vue?vue&type=template&id=4a6aa911&scoped=true"
import script from "./tips2.vue?vue&type=script&lang=js"
export * from "./tips2.vue?vue&type=script&lang=js"
import style0 from "./tips2.vue?vue&type=style&index=0&id=4a6aa911&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6aa911",
  null
  
)

export default component.exports